// Configure un filtrage global des logs: n'autoriser que les logs des 3 activités ciblées
// Conserve console.error intact pour les erreurs critiques

(() => {
  if (typeof window === 'undefined') return;
  if (window.__offisportLoggingPatched) return;

  // Détection d'environnement: activer les logs uniquement en local (localhost, 127.*, 192.168.*)
  const hostname = window.location && window.location.hostname;
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '0.0.0.0';
  const isLan = /^192\.168\./.test(hostname) || /^10\./.test(hostname) || /^172\.(1[6-9]|2\d|3[0-1])\./.test(hostname);
  const enableLogs = isLocalhost || isLan;

  const originalLog = console.log.bind(console);
  const originalInfo = console.info ? console.info.bind(console) : originalLog;
  const originalWarn = console.warn ? console.warn.bind(console) : originalLog;
  const originalDebug = console.debug ? console.debug.bind(console) : originalLog;

  if (!enableLogs) {
    // Neutraliser log/info/debug/warn en production
    console.log = () => {};
    console.info = () => {};
    console.debug = () => {};
    console.warn = () => {};
    // Ne pas toucher à console.error
  } else {
    // En local, conserver les originaux
    console.log = (...args) => originalLog(...args);
    console.info = (...args) => originalInfo(...args);
    console.debug = (...args) => originalDebug(...args);
    console.warn = (...args) => originalWarn(...args);
  }

  window.__offisportLoggingPatched = true;
})();


